import { IUpdateSystemStatusPayload } from 'types/systemStatus.types';
import { AnyAction } from 'redux';
import * as constants from '../constants/systemStatus.constants';

export const getSystemStatus = (): AnyAction => ({
  type: constants.GET_SYSTEM_STATUS_REQUESTED,
});

export const updateSystemStatus = (formData: IUpdateSystemStatusPayload): AnyAction => ({
  type: constants.UPDATE_SYSTEM_STATUS_REQUESTED,
  formData,
});
